import { GetActiveTokens } from './types.ts'

export const getActiveTokens = (): GetActiveTokens => {
	const accessToken = localStorage.getItem('accessToken')
	const accessTokenExpiresAt = localStorage.getItem('accessTokenExpiresAt')
	const organizationToken = localStorage.getItem('organizationToken')
	const organizationId = localStorage.getItem('organizationId')
	const organizationTokenExpiresAt = localStorage.getItem('organizationTokenExpiresAt')

	return {
		accessToken,
		accessTokenExpiresAt: accessTokenExpiresAt ? parseInt(accessTokenExpiresAt, 10) : null,
		organizationToken,
		organizationId,
		organizationTokenExpiresAt: organizationTokenExpiresAt ? parseInt(organizationTokenExpiresAt, 10) : null,
	}
}
